module.exports = __webpack_public_path__ + "img/like.4dbc330d.png";